import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { ValidationDashboardUrl } from './ValidationDashboardUrl';

const postDuplicateVisualValidationCrosstable = ({
  externalCode,
  ...data
}: {
  externalCode: string;
  dataObjectVersionId: number;
}) =>
  apiClient
    .post<{
      externalCode: string;
    }>(
      expand(ValidationDashboardUrl.CROSSTABLE_DUPLICATE, { externalCode }),
      data,
    )
    .then((response) => response.data);

export const useDuplicateVisualValidationCrosstableMutation =
  createApiMutationHook(
    ['duplicateVisualValidationCrosstable'],
    postDuplicateVisualValidationCrosstable,
  );
